<div class="t-widget">
  <!-- <h3 class="t-widgetTitle">
    {{ "translate.rx.items" | translate }}
  </h3> -->

  <div class="workspace-container">
    <div *ngIf="!readOnly" class="header">
      <div class="l-align-spaceBetween">
        <div class="l-align-y col-gap">
          <p-select
            class="t-input--colored item-select"
            [options]="rxItems"
            [(ngModel)]="item"
            [placeholder]="'translate.general.chooseItem' | translate"
            [optionLabel]="'label'"
            (onChange)="onItemChanged()"
            [disabled]="line?.lineId != null"
            [filter]="true"
            [filterBy]="'text,mmdCodesFilter'"
            appendTo="body"
          >
          </p-select>
          <!-- <span
            *ngIf="!form.lines.length"
            class="c-warn mandatory-icon"
            aria-label="שדה חובה"
          >
            (*)
          </span> -->

          <p-selectButton
            *ngIf="item"
            [options]="item.stages"
            [(ngModel)]="stage"
            optionLabel="text"
            [disabled]="!item"
            [unselectable]="true"
          ></p-selectButton>

          <ng-container *ngIf="showCrownBridgeToolbar">
            <ng-container
              *ngTemplateOutlet="
                toolbarSelectBtn;
                context: {
                  $implicit: {
                    code: 'CROWN',
                    icon: 'CROWN',
                    title: 'translate.rx.single' | translate
                  }
                }
              "
            ></ng-container
          ></ng-container>

          <ng-container *ngIf="showCrownBridgeToolbar">
            <ng-container
              *ngTemplateOutlet="
                toolbarSelectBtn;
                context: {
                  $implicit: {
                    code: 'BRIDGE',
                    icon: 'BRIDGE',
                    title: 'translate.rx.splinted' | translate
                  }
                }
              "
            ></ng-container
          ></ng-container>

          <ng-container *ngIf="showRemovableSingleManyToolbar">
            <ng-container
              *ngTemplateOutlet="
                toolbarSelectBtn;
                context: {
                  $implicit: {
                    code: 'CROWN',
                    icon: 'SINGLE_REMOVABLE',
                    title: ''
                  }
                }
              "
            ></ng-container
          ></ng-container>

          <ng-container *ngIf="showRemovableSingleManyToolbar">
            <ng-container
              *ngTemplateOutlet="
                toolbarSelectBtn;
                context: {
                  $implicit: {
                    code: 'BRIDGE',
                    icon: 'MANY_REMOVABLE',
                    title: ''
                  }
                }
              "
            ></ng-container
          ></ng-container>

          <input
            *ngIf="item?.teethQtyType == 'QTY'"
            type="number"
            [(ngModel)]="line.qty"
            class="t-input t-input--colored small"
            min="0"
            [disabled]="readOnly"
            placeholder="{{ 'translate.general.qty' | translate }}"
          />

          <button
            *ngIf="item?.teethQtyType == 'QTY'"
            (click)="addLine()"
            [disabled]="!confirmEnabled()"
            class="t-button-outline c-c1"
          >
            הוספת פריט
          </button>
        </div>

        <div *ngIf="!item" class="l-align-y col-gap">
          <ng-container
            *ngTemplateOutlet="
              toolbarSelectBtn;
              context: {
                $implicit: {
                  code: 'IMPLANT',
                  icon: 'IMPLANT',
                  title: 'translate.rx.implant' | translate
                }
              }
            "
          ></ng-container>
          <ng-container
            *ngTemplateOutlet="
              toolbarSelectBtn;
              context: {
                $implicit: {
                  code: 'EXTRACT',
                  icon: 'EXTRACT',
                  title: 'translate.rx.extract' | translate
                }
              }
            "
          ></ng-container>
        </div>
      </div>

      <!-- <p *ngIf="!errorText" class="help-text">{{ helpText }}</p> -->
      <p *ngIf="errorText" class="err-text">{{ errorText }}</p>
    </div>
    <div
      class="teeth-container"
      id="teeth_cross"
      [class.active]="item"
      [class.deactivated]="item?.teethQtyType == 'QTY'"
    >
      <div
        *ngFor="let t of teeth"
        class="tooth"
        (click)="onToothClick(t)"
        (mouseenter)="onMouseEnter(t)"
        (mouseleave)="onMouseLeave(t)"
        [class.t-pointer]="selectType != null"
        pTooltip="{{ getToothTooltip(t) }}"
        [tooltipPosition]="t.jaw == 0 ? 'top' : 'bottom'"
        [escape]="false"
      >
        <img
          class="bridge-line"
          *ngIf="isMiddleBridge(t, 'BLUE')"
          src="assets\img\teeth_select\bridge_middle_1.svg"
        />
        <img
          class="bridge-line"
          *ngIf="isLeftBridge(t, 'BLUE')"
          src="assets\img\teeth_select\bridge_right.svg"
        />
        <img
          class="bridge-line"
          *ngIf="isRightBridge(t, 'BLUE')"
          src="assets\img\teeth_select\bridge_left.svg"
        />

        <img
          class="green"
          [class.upper]="t.jaw == 0"
          [class.lower]="t.jaw == 1"
          *ngIf="isMiddleBridge(t, 'GREEN')"
          src="assets\img\teeth_select\bridge_middle_green_1.svg"
        />
        <img
          class="green"
          [class.upper]="t.jaw == 0"
          [class.lower]="t.jaw == 1"
          *ngIf="isLeftBridge(t, 'GREEN')"
          src="assets\img\teeth_select\bridge_left_green_1.svg"
        />
        <img
          class="green"
          [class.upper]="t.jaw == 0"
          [class.lower]="t.jaw == 1"
          *ngIf="isRightBridge(t, 'GREEN')"
          src="assets\img\teeth_select\bridge_right_green_1.svg"
        />
        <img
          class="green"
          [class.upper]="t.jaw == 0"
          [class.lower]="t.jaw == 1"
          *ngIf="isSingleGreen(t)"
          src="assets\img\teeth_select\single_green_1.svg"
        />

        <img
          class="implant-icon"
          *ngIf="t.implantSw"
          src="assets\img\teeth_select\implant_on.svg"
          [class.upper]="t.jaw == 0"
          [class.lower]="t.jaw == 1"
        />

        <img
          class="extract-icon"
          *ngIf="t.extractSw"
          src="assets\img\teeth_select\x.svg"
        />

        <ng-container *ngIf="isOutlined(t); else defaultIcon">
          <img class="tooth-img" [src]="t.singleIcon" />
        </ng-container>
        <ng-template #defaultIcon>
          <img class="tooth-img" [src]="t.defaultIcon" />
        </ng-template>
      </div>
    </div>
    <div *ngIf="item && item?.teethQtyType == 'TEETH'" class="action-buttons">
      <button
        *ngIf="!line.lineId"
        (click)="clearSelection()"
        class="t-button-outline warn"
      >
        ביטול
      </button>

      <button
        (click)="addLine()"
        [disabled]="!confirmEnabled()"
        class="t-button-outline c-c1"
      >
        סיום בחירה
      </button>
    </div>
  </div>

  <div *ngIf="tableLines.length > 0" class="tbl-teeth dense">
    <div class="p-datatable iscs-table iscs-table-auto">
      <table class="p-datatable-table">
        <thead class="p-datatable-thead">
          <tr>
            <th>{{ "translate.general.rxItem" | translate }}</th>
            <th>{{ "translate.general.rxStage" | translate }}</th>
            <th>
              {{ "translate.general.toothDisplayText" | translate }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody class="p-datatable-tbody">
          <tr
            *ngFor="let row of tableLines"
            (click)="onLineSelect(row)"
            [class.selected]="line == row"
            (mouseenter)="readOnly ? null : (hoverLine = row)"
            (mouseleave)="hoverLine = null"
          >
            <td>{{ row.rxItem?.text }}</td>
            <td class="td-stage">
              <span *ngIf="row.rxItem.stages.length <= 1">
                {{ row.stage?.text }}</span
              >

              <p-selectButton
                *ngIf="row.rxItem.stages.length > 1"
                [options]="row.rxItem.stages"
                [(ngModel)]="row.stage"
                optionLabel="text"
                [disabled]="readOnly"
                (onChange)="onStageChangeFromTable($event)"
                [unselectable]="true"
              ></p-selectButton>
            </td>
            <td>{{ row.toothDisplayText }}</td>
            <td class="icon-delete">
              <a
                [class.hidden]="line != row && hoverLine != row"
                (click)="deleteRow(row)"
              >
                <img src="assets\img\Delete_small.svg"
              /></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #toolbarSelectBtn let-params>
  <a
    class="toolbar-icon"
    [class.active]="selectType == params.code"
    [class.red]="params.code == 'EXTRACT'"
    (click)="onSelectTypeChange(params.code)"
  >
    <img
      *ngIf="selectType == params.code"
      src="assets\img\teeth_select\{{ params.icon }}_active.svg"
    />
    <img
      *ngIf="selectType != params.code"
      src="assets\img\teeth_select\{{ params.icon }}.svg"
    />
    &nbsp; {{ params.title }}
  </a></ng-template
>
